export default __webpack_public_path__ + "static/media/Icon_Zoonostic.223e2b07.png";